// Mock data for Anand Baral portfolio

export const profile = {
  name: "Anand Baral",
  firstName: "Anand",
  lastName: "Baral",
  tagline: "Blending Creativity with Strategy for Real Results.",
  shortBio:
    "A creative professional specializing in digital marketing, design, and visual storytelling that helps brands grow and stand out.",
  longBio:
    "A creative thinker and digital professional passionate about building impactful visual and digital experiences. With a strong knowledge in marketing, design, and content creation, I focus on delivering work that is not just visually appealing but also result-driven — whether it's creating engaging creatives, managing campaigns, or developing brand identity.",
  roles: [
    "Digital Marketer",
    "Website Designer",
    "Meta Ads Expert",
    "SEO Specialist",
    "Creative Designer",
    "Brand Strategist",
  ],
  location: "Jaipur, Rajasthan, India",
  email: "Mr.anandbaral@gmail.com",
  phone: "+91 7597127506",
  phoneLink: "+917597127506",
  agency: { name: "Aarmbh Media", url: "https://www.aarmbhmedia.com" },
  portraitUrl: "/me.png",
  socials: [
    { label: "LinkedIn", url: "https://www.linkedin.com/in/anand-baral/", handle: "anand-baral" },
    { label: "Instagram", url: "https://www.instagram.com/mr._mischief/", handle: "@mr._mischief" },
    { label: "Twitter", url: "https://x.com/Baral_Sahab", handle: "@Baral_Sahab" },
    { label: "Facebook", url: "https://www.facebook.com/anand.baral.940", handle: "anand.baral" },
  ],
};

export const stats = [
  { value: "5+", label: "Years Experience" },
  { value: "120+", label: "Projects Delivered" },
  { value: "40+", label: "Brands Served" },
  { value: "5.0", label: "Client's Rating" },
];

export const brands = [
  "Ternate Arrow Productions","Political Affair","TMS","Arena Trainings","OkayPlus",
  "Code2Career","SensyTalk","Grovia Info Solution","Arena Info Solution","Apna University","Vedic Astrologer Rahul",
];

export const services = [
  { num: "01", title: "Performance Marketing", desc: "Data-driven ad campaigns on Meta & Google Ads that generate quality leads and maximise ROI.", tags: ["Meta Ads","Google Ads","Funnels"] },
  { num: "02", title: "Website Designing", desc: "Modern, responsive, conversion-focused websites that turn visitors into customers.", tags: ["Webflow","WordPress","UX"] },
  { num: "03", title: "SEO", desc: "On-page + technical SEO that ranks your brand higher and drives sustainable organic growth.", tags: ["On-page","Technical","Content"] },
  { num: "04", title: "Graphic Design", desc: "High-converting ad creatives, social posts and brand visuals that actually stop the scroll.", tags: ["Ad Creatives","Social","Print"] },
  { num: "05", title: "Social Media Management", desc: "Content strategy, consistent posting and community building that grows real audiences.", tags: ["Instagram","LinkedIn","YouTube"] },
  { num: "06", title: "Google My Business", desc: "Local SEO and GMB optimisation that pulls nearby customers and inquiries to your business.", tags: ["GMB","Local SEO","Reviews"] },
  { num: "07", title: "Video Shoot", desc: "Professional reels, brand films and storytelling content that connect with your audience.", tags: ["Reels","Ads","Brand Film"] },
  { num: "08", title: "Branding", desc: "Logos, visual identity and positioning that give your brand a confident voice and look.", tags: ["Logo","Identity","Guidelines"] },
  { num: "09", title: "Content Creation", desc: "Sharp, relevant content written and shot to support your marketing goals across channels.", tags: ["Copy","Scripts","Reels"] },
];

// Tabs for the Work section
export const workCategories = [
  { id: "all",     label: "All Work" },
  { id: "meta",    label: "Meta Ads" },
  { id: "web",     label: "Web Design" },
  { id: "graphic", label: "Graphic Design" },
  { id: "content", label: "Content Creation" },
  { id: "video",   label: "Videos" },
  { id: "photo",   label: "Photography" },
];

// 6 category overview tiles shown in "All Work" tab
export const categoryOverviews = [
  {
    id: "meta",
    label: "Meta Ads",
    desc: "Lead generation & performance campaigns across 5 brands with measurable ROI.",
    count: "5 Brands",
    images: [
      "https://images.unsplash.com/photo-1611926653458-09294b3142bf?w=800&q=80",
      "https://images.unsplash.com/photo-1518734549841-b417d28c22aa?w=800&q=80",
      "https://images.unsplash.com/photo-1622782914767-404fb9ab3f57?w=800&q=80",
    ],
  },
  {
    id: "web",
    label: "Web Design",
    desc: "Full company & portfolio websites built for conversion and brand impact.",
    count: "4 Websites",
    images: [
      "https://images.unsplash.com/photo-1559028012-481c04fa702d?w=800&q=80",
      "https://images.unsplash.com/photo-1597672996375-4d21cad0cbb9?w=800&q=80",
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    ],
  },
  {
    id: "graphic",
    label: "Graphic Design",
    desc: "Ad creatives, social posts, business cards and brand visuals for 8 brands.",
    count: "8 Brands",
    images: [
      "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80",
      "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=800&q=80",
      "https://images.unsplash.com/photo-1572044162444-ad60f128bdea?w=800&q=80",
    ],
  },
  {
    id: "content",
    label: "Content Creation",
    desc: "Strategic content — captions, scripts & post calendars for 6 brands.",
    count: "6 Brands",
    images: [
      "/Images/reels.webp",
      "https://images.unsplash.com/photo-1432888498266-38ffec3eaf0a?w=800&q=80",
      "https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=800&q=80",
    ],
  },
  {
    id: "video",
    label: "Videos",
    desc: "Reels, delivery films, real estate walkthroughs & product shoots.",
    count: "4 Projects",
    images: [
      "https://images.unsplash.com/photo-1584839401450-accbe1a8ef7b?w=800&q=80",
      "https://images.unsplash.com/photo-1611784237648-eeb9be60c61d?w=800&q=80",
      "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80",
    ],
  },
  {
    id: "photo",
    label: "Photography",
    desc: "Product photography & personal travel shots across nature, architecture and more.",
    count: "2 Collections",
    images: [
      "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?w=800&q=80",
      "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&q=80",
      "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=800&q=80",
    ],
  },
];

// Brand-level tiles per category, each with slideshow images
export const brandWorks = {
  meta: [
    {
      id: "m1",
      brand: "TMS Computer Classes",
      type: "Lead Generation",
      desc: "Students admission leads gen — Computer Institute.",
      tag: "Meta Ads",
      metric: "↑ Admission by 38%",
      images: [
        "/Images/tms.webp",
        "/Images/Meta1.png",
        "/Images/meta2.png",
      ],
    },
    {
      id: "m2",
      brand: "Grovia Info Solution",
      type: "Lead Generation",
      desc: "Lead gen campaign — Digital Marketing Agency.",
      tag: "Meta Ads",
      metric: "Increase Leads by 4.2×",
      images: [
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
        "/Images/meta3.png",
        "/Images/meta4.png",
      ],
    },
    {
      id: "m3",
      brand: "Code2Career",
      type: "Performance Funnel",
      desc: "Full-funnel performance campaign — Consultancy Firm.",
      tag: "Meta Ads",
      metric: "3.8× Inquiries",
      images: [
        "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&q=80",
        "/Images/meta5.png",
        "/Images/meta6.png",
      ],
    },
    {
      id: "m4",
      brand: "Apna University",
      type: "Marketing Funnels",
      desc: "Admissions funnels & lead gen — MBBS Abroad Consultancy.",
      tag: "Meta Ads",
      metric: "↑ 3.1× Admissions",
      images: [
        "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&q=80",
        "/Images/meta7.png",
        "/Images/meta8.png",
      ],
    },
    {
      id: "m5",
      brand: "Ternate Arrow Productions",
      type: "Lead Generation",
      desc: "Lead gen campaign — Production House.",
      tag: "Meta Ads",
      metric: "39.8× ROAS",
      images: [
        "https://images.unsplash.com/photo-1478720568477-152d9b164e26?w=800&q=80",
        "/Images/meta9.png",
        "/Images/meta10.png",
      ],
    },
  ],

  web: [
    {
      id: "wb1",
      brand: "Ternate Arrow Productions",
      type: "Full Company Website",
      desc: "Complete company & portfolio website for a production house.",
      tag: "Web Design",
      metric: "Live ↗",
      url: "https://ternatearrowproductions.com/",
      images: [
        "/Images/1.png",
        "/Images/2.png",
        "/Images/3.png",
      ],
    },
    {
      id: "wb2",
      brand: "Grovia Info Solution",
      type: "Digital Marketing Website",
      desc: "Full digital marketing agency website.",
      tag: "Web Design",
      metric: "Live ↗",
      url: "https://groviainfosolution.com/",
      images: [
        "/Images/g1.png",
        "/Images/g2.png",
        "/Images/g3.png",
      ],
    },
    {
      id: "wb3",
      brand: "Apna University",
      type: "Full Website Design",
      desc: "Complete website for an MBBS Abroad consultancy.",
      tag: "Web Design",
      metric: "Live ↗",
      url: "https://apnauniversityabroad.com/",
      images: [
        "/Images/a1.png",
        "/Images/a2.png",
        "/Images/a3.png",
      ],
    },
    {
      id: "wb4",
      brand: "Anand Baral",
      type: "Personal Portfolio",
      desc: "Full portfolio website — the one you're browsing right now.",
      tag: "Web Design",
      metric: "Live ↗",
      url: "https://anandbaral.in/",
      images: [
        "/Images/m1.png",
        "/Images/m2.png",
        "/Images/m3.png",
      ],
    },
  ],

  graphic: [
    {
      id: "g1",
      brand: "Ternate Arrow Productions",
      type: "Meta Ads Creatives",
      desc: "High-performing ad creatives for a production house.",
      tag: "Graphic Design",
      images: [
        "/Images/g/t1.png",
        "/Images/g/t2.png",
        "/Images/g/t3.png",
      ],
    },
    {
      id: "g2",
      brand: "Vedic Astrologer Rahul",
      type: "Ads Creatives",
      desc: "High-performing ad creatives for an astrology brand.",
      tag: "Graphic Design",
      images: [
        "https://images.unsplash.com/photo-1534447677768-be436bb09401?w=800&q=80",
        "/Images/g/r1.png",
        "/Images/g/r2.png",
      ],
    },
    {
      id: "g3",
      brand: "SensyTalk",
      type: "Social Media & Business Card",
      desc: "Social media posts and business card design.",
      tag: "Graphic Design",
      images: [
        "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=800&q=80",
        "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80",
        "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=800&q=80",
      ],
    },
    {
      id: "g4",
      brand: "Recent Brands",
      type: "Logo Design",
      desc: "Complete logo and brand identity design.",
      tag: "Branding",
      images: [
        "/Images/g/p.png",
        "/Images/g/tl.png",
        "/Images/g/gl.png",
        "/Images/g/aml.png",
        "/Images/g/al.png",
      ],
    },
    {
      id: "g5",
      brand: "Code2Career",
      type: "Meta Ad Creatives",
      desc: "Scroll-stopping ad creatives for a career consultancy.",
      tag: "Graphic Design",
      images: [
        "/Images/g/c.png",
        "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80",
        "https://images.unsplash.com/photo-1626785774625-ddcddc3445e9?w=800&q=80",
      ],
    },
    {
      id: "g6",
      brand: "Arena Info Solution",
      type: "Social Media Posts",
      desc: "Consistent social media post design system.",
      tag: "Graphic Design",
      images: [
        "/Images/g/a1.jpg",
        "/Images/g/a2.jpg",
        "/Images/g/a3.jpg",
      ],
    },
    {
      id: "g7",
      brand: "TMS",
      type: "Ads Creatives",
      desc: "High-performing ad creatives for a computer institute.",
      tag: "Ad Creatives",
      images: [
        "/Images/g/tm1.png",
        "/Images/g/tm2.png",
        "/Images/g/tm3.png",
      ],
    },
    {
      id: "g8",
      brand: "Apna University",
      type: "PPT & Social Posts",
      desc: "Presentation design and social media post creatives.",
      tag: "Graphic Design",
      images: [
        "/Images/g/u1.jpg",
        "/Images/g/u2.jpg",
      ],
    },
  ],

  content: [
    {
      id: "c1",
      brand: "Ternate Arrow Productions",
      type: "Content Strategy",
      desc: "Captions, scripts and content calendar for a production house.",
      tag: "Content Creation",
      video: "/Images/v/tap.mp4",
      images: [],
    },
    {
      id: "c2",
      brand: "Code2Career",
      type: "Content Strategy",
      desc: "Educational content, reels scripts and post copy.",
      tag: "Content Creation",
      video: "/Images/v/c.mp4",
      images: [],
    },
    {
      id: "c3",
      brand: "Arena Info Solution",
      type: "Social Media Content",
      desc: "Monthly content calendar, captions and campaign copy.",
      tag: "Content Creation",
      video: "/Images/v/arena.mp4",
      images: [],
    },
    {
      id: "c4",
      brand: "Apna University",
      type: "Content Strategy",
      desc: "Admissions-focused content for MBBS Abroad consultancy.",
      tag: "Content Creation",
      video: "/Images/v/apna.mp4",
      images: [],
    },
    {
      id: "c5",
      brand: "Arena Trainings",
      type: "Social Media Content",
      desc: "Content strategy and posts for a training institute.",
      tag: "Content Creation",
      video: "/Images/v/arenat.mp4",
      images: [],
    },
    {
      id: "c6",
      brand: "Grovia Info Solution",
      type: "Content Strategy",
      desc: "Agency content — posts, ad copy and campaign scripts.",
      tag: "Content Creation",
      video: "/Images/v/gro.mp4",
      images: [],
    },
  ],

  video: [
    {
      id: "v1",
      brand: "Car Delivery Reels",
      type: "Video Production",
      desc: "Cinematic car delivery reels for social media.",
      tag: "Reels",
      video: "/Images/v/car.mp4",
      images: [],
    },
    {
      id: "v2",
      brand: "Real Estate Videos",
      type: "Video Production",
      desc: "Property walkthrough videos and promotional films.",
      tag: "Brand Film",
      video: "/Images/v/villa.mp4",
      images: [],
    },
    {
      id: "v3",
      brand: "Products Shoot",
      type: "Product Video",
      desc: "Clean, high-detail product shoot videos.",
      tag: "Product Video",
      video: "/Images/v/pro.mp4",
      images: [],
    },
    {
      id: "v4",
      brand: "Reels",
      type: "Short-Form Video",
      desc: "Engaging short-form reels crafted for reach and retention.",
      tag: "Reels",
      video: "/Images/v/reel.mp4",
      images: [],
    },
  ],

  photo: [
    {
      id: "p1",
      brand: "Product Shoots",
      type: "Product Photography",
      desc: "Clean, commercial-grade product photography for brands.",
      tag: "Photography",
      images: [
        "https://images.unsplash.com/photo-1471341971476-ae15ff5dd4ea?w=800&q=80",
        "/Images/p2.jpg",
        "/Images/p1.jpg",
      ],
    },
    {
      id: "p2",
      brand: "Personal Photography",
      type: "Travel & Nature",
      desc: "Nature, architecture, animals and monuments captured through my lens.",
      tag: "Photography",
      url: "https://capture.anandbaral.in/",
      images: [
        "/Images/p/p1.jpg",
        "/Images/p/p2.jpg",
        "/Images/p/p3.jpg",
        "/Images/p/p4.jpg",
      ],
    },
  ],
};

export const skills = [
  { name: "Meta Ads", value: 95 },
  { name: "Website Designing", value: 92 },
  { name: "SEO", value: 85 },
  { name: "Branding", value: 88 },
  { name: "Content Creation", value: 90 },
  { name: "Photo & Video Shoot", value: 82 },
];

export const process = [
  { num: "01", title: "Understanding & Research", desc: "Deep-dive into your business, audience, competitors and market to build a strong foundation." },
  { num: "02", title: "Strategy & Planning", desc: "Creative direction, channel mix, campaign roadmap and measurable KPIs — all locked before execution." },
  { num: "03", title: "Design & Execution", desc: "Craft the creatives, websites and campaigns with obsessive attention to performance and detail." },
  { num: "04", title: "Testing & Optimization", desc: "Continuous A/B testing, analytics review and iteration to squeeze every percent of performance." },
  { num: "05", title: "Growth & Scaling", desc: "Once results are proven, we scale spend, content and systems for sustainable long-term growth." },
];

export const testimonials = [
  { name: "Pawan Karadiya", role: "Founder & CEO", quote: "Working with Anand was a great experience. He understands both design and marketing, which helped us generate quality leads through our ad campaigns. Highly recommended!" },
  { name: "Medha Sharma", role: "Operations Manager", quote: "Professional, creative, and result-oriented. The website he designed for us not only looks amazing but also improved our customer inquiries significantly." },
  { name: "Rahul Sharma", role: "Astrologer", quote: "Great understanding of ads and audience targeting. He helped us reduce our cost per lead and improve conversions through proper campaign optimization." },
  { name: "Viraj", role: "Job Consultant", quote: "Creative work with a strategic approach. The branding and designs perfectly matched our vision. Clean, modern, and highly effective." },
  { name: "Shiv Shankar Gupta", role: "Institute Owner", quote: "Our social media completely transformed. From creatives to content strategy, everything was on point. Engagement and reach improved within weeks." },
];

export const valueProps = [
  "Strategic Planning for Better Results",
  "Deep Understanding of Your Business & Audience",
  "Creative Solutions that Drive Performance",
  "Reliable Support & Clear Communication",
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];
